module.exports = {
  wrapperStyle: () => ({
    width: '100vw',
    height: '100vh'
  })
}
